import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[loaded]',
  standalone: true
})
export class ImageBaseDirective {
  private elRef = inject<ElementRef<HTMLImageElement>>(ElementRef<HTMLImageElement>);
  @Output() loaded = new EventEmitter<boolean>();

  _src = '';
  @Input()
  set src(value: string | null) {
    if (value) {
      this.elRef.nativeElement.style.display = 'none';
      this.elRef.nativeElement.src = value;
    }
  }

  @HostListener('load')
  onLoad(): void {
    this.loaded.emit(true);
    this.elRef.nativeElement.style.display = 'initial';
  }

  constructor() {
    this.elRef.nativeElement.style.display = 'none';
    if (this.elRef.nativeElement.complete) {
      this.loaded.emit(true);
    }
  }
}
